import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UiSkeletonElementAvatarComponent } from "./components/skeleton-element-avatar/skeleton-element-avatar.component";
import { UiSkeletonElementButtonComponent } from "./components/skeleton-element-button/skeleton-element-button.component";
import { UiSkeletonElementImageComponent } from "./components/skeleton-element-image/skeleton-element-image.component";
import { UiSkeletonElementInputComponent } from "./components/skeleton-element-input/skeleton-element-input.component";
import { UiSkeletonLineComponent } from "./components/skeleton-line/skeleton-line.component";
import { UiSkeletonElementDirective } from "./directives/skeleton-element.directive";
import { UiSkeletonComponent } from "./skeleton.component";

@NgModule({
  imports: [CommonModule],
  declarations: [
    UiSkeletonElementImageComponent,
    UiSkeletonElementInputComponent,
    UiSkeletonElementButtonComponent,
    UiSkeletonElementAvatarComponent,
    UiSkeletonElementDirective,
    UiSkeletonComponent,
    UiSkeletonLineComponent,
  ],
  exports: [
    UiSkeletonElementImageComponent,
    UiSkeletonElementInputComponent,
    UiSkeletonElementButtonComponent,
    UiSkeletonElementAvatarComponent,
    UiSkeletonElementDirective,
    UiSkeletonComponent,
    UiSkeletonLineComponent,
  ],
})
export class UiSkeletonModule {}
